import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

import type { CachedOrg } from '@bb/automaton';
import type {
  IAnsweringOrgGroup,
  BuildJsonType,
  IIDs,
  ITimestamps,
} from '@bb/domain/dist/types';

type OrgData = Pick<CachedOrg, 'id' | 'locations' | 'name'>;

export interface IGetOrgsByGroupResponse {
  hasMore: boolean;
  groups: (Omit<
    BuildJsonType<IAnsweringOrgGroup & IIDs & ITimestamps>,
    'orgs'
  > & { orgs: OrgData[] })[];
  notGroupedOrgs: OrgData[];
}

const getOrgsByGroup = async (skip: string, limit: string) => {
  const urlSearchParms = new URLSearchParams({ skip, limit });
  const config: AxiosRequestConfig = {
    url: `/answering/orgs_by_group?${urlSearchParms}`,
    method: 'get',
  };

  const { data } = await axios.request<IGetOrgsByGroupResponse>(config);

  return data;
};

export default getOrgsByGroup;
